import { Routes } from '@angular/router';
import { calGuard } from '@cvx/cal-angular';
import { APP_ROUTES } from './core/constants/app-navigation.constants';

export const routes: Routes = [
  {
    path: 'unauthorized',
    loadComponent: () => import('./layout/unauthorized/unauthorized').then((m) => m.Unauthorized),
  },
  {
    path: 'error',
    loadComponent: () => import('./layout/error/error').then((m) => m.Error),
    data: { notFound: false },
  },
  {
    path: '',
    pathMatch: 'full',
    canActivate: [calGuard],
    loadComponent: () => import('./layout/home/home').then((m) => m.Home),
  },
  {
    path: APP_ROUTES.INFORMATION.ROOT,
    canActivate: [calGuard],
    loadChildren: () =>
      import('./features/information/information.routes').then((m) => m.INFORMATION_ROUTES),
  },
  {
    path: APP_ROUTES.INSPECTION.ROOT,
    canActivate: [calGuard],
    loadChildren: () =>
      import('./features/inspection/inspection.routes').then((m) => m.INSPECTION_ROUTES),
  },
  {
    path: APP_ROUTES.OPERATIONS.ROOT,
    canActivate: [calGuard],
    loadChildren: () =>
      import('./features/operations/operations.routes').then((m) => m.OPERATIONS_ROUTES),
  },
  {
    path: APP_ROUTES.BULK.ROOT,
    canActivate: [calGuard],
    loadChildren: () => import('./features/bulk/bulk.routes').then((m) => m.BULK_ROUTES),
  },
  {
    path: APP_ROUTES.MATERIAL.ROOT,
    canActivate: [calGuard],
    loadChildren: () =>
      import('./features/material/material.routes').then((m) => m.MATERIAL_ROUTES),
  },
  {
    path: APP_ROUTES.ROUTE.ROOT,
    canActivate: [calGuard],
    loadChildren: () => import('./features/route/route.routes').then((m) => m.ROUTE_ROUTES),
  },
  {
    path: APP_ROUTES.SHOREBASE.ROOT,
    canActivate: [calGuard],
    loadChildren: () =>
      import('./features/shorebase/shorebase.routes').then((m) => m.SHOREBASE_ROUTES),
  },
  {
    path: APP_ROUTES.REPORTS.ROOT,
    canActivate: [calGuard],
    loadChildren: () => import('./features/reports/reports.routes').then((m) => m.REPORTS_ROUTES),
  },
  {
    path: APP_ROUTES.ADMIN.ROOT,
    canActivate: [calGuard],
    loadChildren: () => import('./features/admin/admin.routes').then((m) => m.ADMIN_ROUTES),
  },
  {
    path: '**',
    loadComponent: () => import('./layout/error/error').then((m) => m.Error),
    data: { notFound: true },
  },
];
